export const serviceCenters = {
  table: {
    serviceCenterName: "اسم مركز الخدمة",
    serviceTypes: "أنواع الخدمات",
    address: "العنوان",
    line:"الخط",
    city:"المدينة",
  },
  totalProviders: "إجمالي عدد مراكز الخدمة",
  serviceCenterTypes: {
    mobil_autocare: "موبيل أوتوكير",
    station: "محطات",
    mobil_1_center: "موبيل 1 سنتر",
    dealer: "تجار",
  },
};
